import Image from 'next/image';
import { shimmeringBackgroundEventImage } from './ShimmeringImageLoadingPlaceholder';
import React from 'react';

export default function PresignedUrlImage({ imageId, ...props }: React.ComponentProps<typeof Image> & { imageId: string | number }) {
  // When using a presigned url image, the image will flash each time the data is refreshed.
  // This is because the presigned url changes.
  // Below aims to make this reference stable, by only updating when the id of the image updates.
  const stableImageSrc = React.useMemo(() => {
    return props.src;
  }, [imageId]);
  return (
    <Image
      {...props}
      src={stableImageSrc}
      unoptimized
      blurDataURL={shimmeringBackgroundEventImage({ width: Number(props.width), height: Number(props.height) })}
    />
  );
}
